var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('EventCategoryTimes', {
    attrs: {
      "data": _vm.event,
      "details": _vm.details,
      "new_version": false
    },
    on: {
      "doToggle": _vm.doToggle
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-4 event-listing-img"
  }), _c('section', {
    staticClass: "col-md-8 event-listing-detail pt-4"
  }, [_vm.loggedIn ? _c('div', [_vm.event.accept ? [_vm.event.ustatus === 'pending' ? [_c('p', {
    staticClass: "alert alert-warning alert-12"
  }, [_vm._v(" Your registration for this event is in process, soon you will receive a confirmation email. ")])] : _vm.event.ustatus === 'approved' ? [_c('p', {
    staticClass: "alert alert-success alert-12"
  }, [_vm._v(" Congratulations! Your registration for this event has been approved. ")])] : _vm.event.ustatus === 'declined' && _vm.join === true ? [_c('p', {
    staticClass: "alert alert-danger alert-12"
  }, [_vm._v(" Your request for this event is declined. please contact support for further details ")]), _c('a', {
    staticClass: "btn-universal",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.joinEvent(_vm.event.id);
      }
    }
  }, [_vm._v("Re Join")])] : [_vm.join && _vm.checkEmptySlots() && _vm.canParticipate ? _c('a', {
    staticClass: "btn-universal",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.joinEvent(_vm.event.id);
      }
    }
  }, [_vm._v("Join")]) : _vm._e(), !_vm.checkEmptySlots() ? _c('p', {
    staticClass: "alert alert-warning alert-12"
  }, [_vm._v(" The room is already fill for this event. ")]) : _vm._e(), !_vm.canParticipate ? _c('p', {
    staticClass: "alert alert-warning alert-12"
  }, [_vm._v(" " + _vm._s(_vm.eventMessage) + " ")]) : _vm._e()]] : [_c('p', {
    staticClass: "alert alert-warning alert-12"
  }, [_vm._v(" Registration for this event has been closed. ")])]], 2) : _c('div', {
    staticClass: "tidw text-danger text-center mb-2"
  }, [_vm._v(" Login or create an account to register for this event. ")]), _c('EventLinks', {
    attrs: {
      "links": _vm.getLinks,
      "new_version": false
    }
  })], 1)]), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_vm.toggle ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "event-description"
  }, [_c('h4', [_vm._v("DESCRIPTION")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.event.details)
    }
  })])])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }